import { Component, Input } from "@angular/core";
import { LOCALIDADES_BOGOTA } from "src/app/comun/data/localidades-bogota";
import { Localidad } from "src/app/comun/models/localidad";

const HINT_ACTIVOS =
  'Es la sumatoria de los bienes, inventarios o productos y facturas que te deban tus clientes';

@Component({
    selector: 'beneficiario-juridica',
    templateUrl: './beneficiario.template.html',
    styleUrls: ['./beneficiario.template.scss'],
    standalone: false
})
export class BeneficiarioJuridica{
    usuario: any = null;
    localidades: ReadonlyArray<Localidad> = LOCALIDADES_BOGOTA;
    readonly hintActivos = HINT_ACTIVOS;
    activosHintOpen = false;
    activosHintStyle: Record<string, string> = {};

    @Input('beneficiario') beneficiario : any = {
        AnioDeActivos: "",
        AnioDeVentas: "",
        barrioEmpresa: "",
        direccionEmpresa:"",
        CiudadResidencia: [],
        DepartamentoResidencia: [],
        EstadoCivil: "",
        FechaDeExpedicionDelDocumento: "",
        FechaDeNacimiento: "",
        Genero: "",
        NivelDeActivos: 0,
        NivelDeEstudios: "",
        NivelDeVentas: 0,
        NombreDeContacto: "",
        NumeroDeDocumento: "",
        PagaSeguridadSocial: "",
        PrimerApellido: "",
        PrimerNombre: "",
        SegundoApellido: "",
        SegundoNombre: "",
        TipoDeDocumentoDeIdentidad: "",
        TipoDeVivienda: "",
        personaNatural: false,
        HaTenidoCredito:"",
        fechaCreditoAnterior:"",
        minoria:"",
        minoriaDescripcion:"",
        idFuenteNeocredito: '',
        nombreFuente: '',
        nombreReferido:'',
        codigoReferido:'',
        otraFuente:'',
        numeroOpcional:"",
        pais:"",
        tiposContacto: "",
        camaraComercioVigente: "",
        idLocalidad: ""
    };

    @Input('existePropuesta') existePropuesta : boolean;
    @Input('esIntermediario') esIntermediario: boolean;

    getNombreLocalidad(id: number): string {
        const loc = this.localidades.find(l => l.id === id);
        return loc ? loc.nombre : '';
    }

    showActivosHint(event: Event): void {
      const btn = event.currentTarget as HTMLElement | null;
      if (!btn) {
        return;
      }
      const rect = btn.getBoundingClientRect();
      this.activosHintStyle = {
        top: `${Math.max(8, rect.top - 12)}px`,
        left: `${rect.left + rect.width / 2}px`,
      };
      this.activosHintOpen = true;
    }

    hideActivosHint(): void {
      this.activosHintOpen = false;
    }
}
